import CustomerAnnouncementLayout from "../../components/layouts/CustomerAnnouncementLayout";

const DataSend = () => {
    return (
        <CustomerAnnouncementLayout>
            <div className="mt-5">
                <p>
                    Bedankt voor het verzenden van de huidige status van uw lift.
                </p>
                <p>
                    Heeft u nog vragen? Neem dan contact op met
                    Chex via <strong>planning@chex.nl</strong>.
                </p>

                <p>U kunt deze pagina nu sluiten.</p>
            </div>
        </CustomerAnnouncementLayout>
    );
};

export default DataSend;
